import { Tooltip } from "@mui/material";
import { useNetwork } from "../../../../context/NetworkContext";
import AxiosInstance from "../../../AxiosInstance";
import { usePermission } from "../../../../context/PermissionContext";
import { useAuth } from "../../../../context/AuthProvider";
import handleError from "../../../../constants/handleError";
import { useEffect } from "react";
import { useShowAlert } from "../../../../context/AlertContext";
import axios from "axios";
const InvoiceToggleActionCard = ({ optData,isPurchase,returnTrack, setOptData ,setBilling,setSelectTermalOption,setSelectHALFA4Option,isPreSale}) => {

    const { checkNetwork } = useNetwork();
    const {storeSettings} = usePermission();
    const { updateSettings } = useAuth();
    const showAlert = useShowAlert();

    const handleUpdate = async (field, value) => {
      try {
        if (!checkNetwork()) return;
  
        const data = {
          saleSettings: {
            ...optData,
            [field]: value,
          },
        };
  
        const response = await AxiosInstance.patch(`module/storesettings`, data);
  
        const result = response?.data?.results?.saleSettings;
  
        updateSettings({
          storeSettings: {
            ...storeSettings,
            saleSettings: {
              ...storeSettings?.saleSettings,
              [field]: result[field],
            },
          },
        });
      } catch (error) {
        handleError(error, showAlert);
      }
    };

    const handleCheckPrintService = async () => {
     try {
      if (!checkNetwork()) return;
      const response = await axios.get("http://127.0.0.1:9164/ping", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = response.data;
      if (result) {
        setBilling(true);
      }
    } catch (error) {
      return null;
    }
  };
      useEffect(() => {      
        const id = storeSettings?.invoiceSettings?.template?.templateId || "";
        const words = id ? id?.split("AND") : [];
        // setSelectedOption(words[0]);
        setSelectTermalOption(words[1] || "TMLBAS");
        setSelectHALFA4Option(words[2] || "HA4RET");
         if (storeSettings?.printSystemSettings?.printThrough) {
        handleCheckPrintService();
         }
     
      }, []);      
      const toggleItems = [
        isPurchase
      ? {
          field: "isSupplier",
          titleOn: "Hide Supplier",
          titleOff: "Show Supplier",
          icon: "bi bi-truck",
        }: 
        {
          field: "isCustomerDisplay",
          titleOn: "Hide Customer",
          titleOff: "Show Customer",
          icon: "ng ng-ng-customers-icon",
        },
        
        {
          field: "isRemark",
          titleOn: "Hide Remark",
          titleOff: "Show Remark",
          icon: "bi bi-chat-left-text",
        },
        ...(!isPurchase  && !returnTrack && !isPreSale
    ? 
        [ {
          field: "isPayment",
          titleOn: "Hide Payment Mode",
          titleOff: "Show Payment Mode",
          icon: "bx bx-credit-card",
          font:"font-20"
        }]:[]),
         ...(!isPurchase  && !returnTrack && !isPreSale
    ? 
        [ {
          field: "isBankDetails",
          titleOn: "Hide Payment Details",
          titleOff: "Show Payment Details",
          icon: "bi bi-bank",
          font:"font-20"
        }]:[]),
      
      ];   
   
  return (
    <div className="border-end pt-0 d-flex flex-column align-items-center temp-right-bar">
      {toggleItems.map((item) => {
        const isActive = optData?.[item.field];
        return (
          <div className="mt-2" key={item.field}>
            <Tooltip
              title={isActive ? item.titleOn : item.titleOff}
              arrow>
              <div
                onClick={() =>
                  setOptData((prev) => ({
                    ...prev,
                    [item.field]: !prev[item.field],
                  }))
                }
                style={{
                  width: "52px",
                  height: "52px",
                  borderRadius: "14px",
                  cursor: "pointer",
                  border: isActive
                    ? "1px solid #fed7aa"
                    : "1px solid #ececec",
                  background: "#fff",
                  transition: "all 0.2s ease",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-1px)";
                  e.currentTarget.style.boxShadow =
                    "0 2px 6px rgba(0,0,0,0.08)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0px)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  className={`d-flex justify-content-center align-items-center radius-10 w-34 h-34 ${
                    isActive ? "bg-label-infoss" : "btn btn-gray"
                  }`}
                  style={{ transition: "all 0.2s ease" }}
                >
                  <i
                    className={`${item.icon} ${item?.font ? item?.font :"font-18"} ${
                      isActive ? "active" : "text-secondary"
                    }`}
                  />
                </div>

                {/* <div
                  className="position-absolute rounded-circle"
                  style={{
                    bottom: "6px",
                    right: "6px",
                    width: "8px",
                    height: "8px",
                    // background: isActive ? "#22c55e" : "#d1d5db",
                    border: "1px solid #fff",
                  }}
                /> */}
              </div>
            </Tooltip>
          </div>
        );
      })}
    </div>
  );
};

export default InvoiceToggleActionCard;
